import { render, staticRenderFns } from "./lock-ui.vue?vue&type=template&id=3254de0a&scoped=true"
import script from "./lock-ui.vue?vue&type=script&lang=js"
export * from "./lock-ui.vue?vue&type=script&lang=js"
import style0 from "./lock-ui.vue?vue&type=style&index=0&id=3254de0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3254de0a",
  null
  
)

export default component.exports